import React, { useState, useEffect, useRef } from "react";
import ElementsController from "./ElementsController";
import NoImageController from "./NoImageController";
import ScheduleEdit from "./ScheduleEdit";
import "../Schedule/Schedule.css";
import axios from "axios";
// import schedule from "../json/schedule.json";
import { set } from "internal-slot";
import DOMPurify from "dompurify";


const ScheduleController = () => {
    const fileInputRef = useRef(null);
    const [currentId, setCurrentId] = useState(null);
    const [selectedData, setSelectedData] = useState([]);
    const [refreshFlag, setRefreshFlag] = useState(false);
    const [addData, setAddData] = useState([]);
    const [addPreview, setAddPreview] = useState([]);
    const [selectedImage, setSelectedImage] = useState(null);
    const [previewImage, setPreviewImage] = useState(null);
    const [previewContent, setPreviewContent] = useState([]);
    const [nowEditing, setNowEditing] = useState(false);
    const [nowCreating, setNowCreating] = useState(false);
        const [getScheduleDate, setGetScheduleDate] = useState([{
        date: "",
        image_path: "",
        location: "",
        address: "",
        title: "",
        artist: "",
        contents: "",
        open_time: "",
        start_time: "",
        door_price: "",
        adv_price: "",
        drink_price: "",
        etc: "",
    }]);

    const BASE_URL = "http://localhost:8000/storage";

    //データの取得
    useEffect(() => {
        const getSchedule = async () => {
            try {
                const response = await axios.get("http://127.0.0.1:8000/api/schedules");
                console.log("API Response:", response.data); // ここで構造を確認

                setGetScheduleDate(response.data);

            } catch (error) {
                console.error("データを取得できませんでした", error);
            }


        }
        getSchedule();
        console.log("getScheduleDate:", getScheduleDate);

    }, [refreshFlag]);



    //データの追加

    const addContent = async (data) => {
        console.log("送信データ:", data);

        try {
            const formData = new FormData();
            for (const key in data) {
                formData.append(key, data[key]);
            }

            if (selectedImage) {
                formData.append("image", selectedImage);
            }

            const response = await axios.post("http://127.0.0.1:8000/api/schedules/", formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                }
            });
            if (response.status === 201) {
                alert("追加に成功しました。");
                setRefreshFlag(!refreshFlag);

            } else {
                console.error("保存に失敗しました。", response);
                alert("保存に失敗しました。");
            }
        } catch (error) {
            console.error("追加に失敗しました。", error);
            alert("追加に失敗しました。");
        }
    }

    // データの更新

    const updateContent = async (id, data) => {
        console.log("更新データ", data);

        try {
            const formData = new FormData();
            // for (const key in data) {
            //     formData.append(key, data[key]);
            // }
            formData.append("date", data.date);
            formData.append("location", data.location);
            formData.append("address", data.address);
            formData.append("title", data.title);
            formData.append("artist", data.artist);
            formData.append("contents", data.contents);
            formData.append("open_time", data.open_time);
            formData.append("start_time", data.start_time);
            formData.append("adv_price", data.adv_price);
            formData.append("door_price", data.door_price);
            formData.append("drink_price", data.drink_price);
            formData.append("etc", data.etc);
            if (selectedImage) {
                formData.append("image", selectedImage);
            }

            for (let pair of formData.entries()) {
                console.log(pair[0] + ': ' + pair[1]);
            }

            const response = await axios.post(`http://127.0.0.1:8000/api/schedules/${id}`, formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            });


            if (response.status === 200) {
                alert("更新に成功しました。");
                setRefreshFlag(!refreshFlag);
                setNowEditing(false);
                // あとで画像などのクリーンアップを追加

            } else {
                console.error("更新に失敗しました。", response);
                alert("更新に失敗しました。");
            }


        } catch (error) {
            console.error("更新処理中にエラーが発生しました。", error);
            alert("更新処理中にエラーが発生しました。");
        }
    }

    //データの削除

    const deleteContent = async (id) => {
        try {
            const response = await axios.delete(`http://127.0.0.1:8000/api/schedules/${id}`);
            setRefreshFlag(!refreshFlag);
            if (response.status === 200) {
                alert("削除に成功しました。");
            } else {
                alert("削除に失敗しました。");
            }
        } catch (error) {
            console.error("データ削除できませんでした。", error);
        }
    }


    const handleAddContents = (e) => {
        e.preventDefault();
        const { name, value } = e.target;
        setAddData((prev) => ({ ...prev, [name]: value }));
        console.log("addData", addData);
    }


    const handleImagePreview = (e) => {
        const fileInput = e.target; // input[type="file"]要素を取得
        if (!previewImage) { //画像が選択されていない場合
            const file = fileInput.files[0];//選択されたファイル

            if (file) {
                setSelectedImage(file);
                const reader = new FileReader();
                reader.onload = () => {
                    setPreviewImage(reader.result);
                };
                reader.readAsDataURL(file);
                console.log(previewImage);
            }
        } else {
            setSelectedImage(null);
            setPreviewImage(null);
            fileInput.value = "";
        }
    }

    const deleteSelectedImage = () => {
        setSelectedImage(null);
        setPreviewImage(null);
        if (fileInputRef.current) {
            fileInputRef.current.value = "";
        }
    }

    const deleteImagePath = () => {
        setPreviewContent((prevState) => ({
            ...prevState, // 他のプロパティはそのまま維持
            image_path: "", // image_path のみを更新
        }));
    }

    const handleSelect = (e) => {
        e.preventDefault();
        const id = e.currentTarget.id;
        if (!nowEditing) {
            const selected = getScheduleDate.find((data) => data.id.toString() === id);
            if (selected) {
                setPreviewContent(selected);
                setCurrentId(id);
                setNowEditing(true);
                setNowCreating(false);
                console.log("aaaaaa");
            } else {
                alert("データが見つかりませんでした。");
            }
        } else {
            setNowEditing(false);
            setCurrentId(null);
            setSelectedData([]);
        }
    }

    const handlePreviewContent = (e) => {
        e.preventDefault();
        const { name, value } = e.target;
        setPreviewContent((prev) => ({ ...prev, [name]: value }));
        console.log("previewContent", previewContent);

    }


    const createSafeHTML = (html) => {
        return { __html: DOMPurify.sanitize(html) };
    };

    const insertStr = (str) => {
        if (!str || str.length < 10) {
            // strがundefinedまたは短すぎる場合はそのまま返すか、デフォルト値を返す
            return str || "日付未設定";
        }
        return (
            str.slice(0, 4) +
            "年" +
            str.slice(5, 7) +
            "月" +
            str.slice(8, 10) +
            "日"
        );
    }

    useEffect(() => {
        console.log(selectedImage);
    }, [selectedImage]);

    const handleEditMode = () => {
        setNowEditing(!nowEditing);
        setNowCreating(false);
        setPreviewImage("");
        setPreviewContent([]);
        console.log("edit:" + previewImage);
    }
    const handleCreateMode = () => {
        setNowCreating(!nowCreating);
        setNowEditing(false);
        setPreviewImage("");
        setAddData([]);
        console.log("create:" + previewImage);

    }

    return (
        <div>
            <div>
                <button onClick={() => handleCreateMode()} className="schedule-contents-button">{nowCreating ? "閉じる" : "新規作成"}</button>
            </div>

            {/* 追加モードプレビュー */}
            <div>
                <div className={nowCreating ? "schedule-contents-wrapper" : "display-none"} id={selectedData.id}>

                    <div className="schedule-contents-title-wrapper">
                        <div className="schedule-contents-title-inner">
                            <div className="schedule-contents-date">
                                {insertStr(addData.date)}
                            </div>
                            <div className="schedule-contents-location">
                                @{addData.location}
                            </div>
                            <div className="schedule-contents-title">
                                【{addData.title}】
                            </div>
                        </div>
                        <div>
                            {/* <button className="schedule-controll-button" id={addData.id} onClick={() => { setNowEditing(true) }}>編集</button>
                                    <button className="schedule-controll-button" id={addData.id} onClick={() => { deleteContent(addData.id) }}>削除</button> */}

                        </div>
                    </div>
                    <div className="schedule-contents-body">
                        <div className="schedule-image">
                            {addData.image_path && <img src={`${BASE_URL}/${addData.image_path}`} alt={addData.data} className='schedule-image-image' />}
                            {previewImage && <img src={previewImage} alt="preview" className="schedule-image-image" />}<br />
                            {!previewImage && !addData.image_path && <NoImageController />}
                            {previewImage && addData.image_path && <img src={`${BASE_URL}/${addData.image_path}`} alt={addData.date} className='schedule-image-image' />}
                            {/* {!addData.image_path && !previewImage && <input type="file" name="image" accept="image/*" onChange={handleImagePreview} ref={fileInputRef} />}
                            {addData.image_path && <button type="button" onClick={() => { deleteImagePath() }}>画像を削除する</button>}
                            {previewImage && <button type="button" onClick={() => { deleteSelectedImage() }}>画像を削除する</button>} */}
                        </div>
                        <div className="schedule-contents-contents">
                            日時：{insertStr(addData.date)}<br />
                            会場：{addData.location}<br />
                            {addData.address}<br />
                            <br />
                            Open:{addData.open_time}/Start:{addData.start_time}<br />
                            adv:{addData.adv_price}/door:{addData.door_price}/{addData.drink_price}<br />
                            {addData.etc}<br />
                            <br />
                            出演：{addData.artist}<br />
                            <br />
                            <div dangerouslySetInnerHTML={createSafeHTML(addData.contents)} />



                        </div>


                    </div>

                </div>

            </div>




            {/* 追加モード */}
            <section className={nowCreating ? 'schedule-add-section-wrapper' : 'display-none'}>
                <form onSubmit={(e) => {
                    e.preventDefault();
                    addContent(addData);
                    setNowEditing(false);
                    setNowCreating(false);
                    setAddData([]);
                    setPreviewImage("");

                }}>
                    <div className={nowCreating ? 'schedule-contents-wrapper' : 'display-none'} id="add-schedule">

                        <div className="schedule-contents-title-wrapper">
                            <div className="schedule-contents-title-inner">
                                <div className="schedule-contents-date">
                                    新規作成中
                                </div>
                                <div className="schedule-contents-button-wrapper">
                                    <button type="submit" className="schedule-contents-button" >保存</button>
                                    <button>削除</button>

                                </div>
                            </div>
                        </div>
                        <div className="schedule-contents-body">
                            <div className="schedule-image">
                                {/* {imagePath ? <a href={imagePath} target="_blank"><img src={imagePath} alt={id} className="schedule-image-image" /> </a> : <NoImage />} */}
                                {addData.image_path && <img src={`${BASE_URL}/${addData.image_path}`} alt={addData.id} className='schedule-image-image' />}
                                {previewImage && <img src={previewImage} alt="preview" className="schedule-image-image" />}<br />
                                {!previewImage && !addData.image_path && <NoImageController />}
                                {previewImage && addData.image_path && <img src={`${BASE_URL}/${addData.image_path}`} alt={addData.id} className='schedule-image-image' />}
                                {!addData.image_path && !previewImage && <input type="file" name="image" accept="image/*" onChange={handleImagePreview} ref={fileInputRef} />}
                                {addData.image_path && <button type="button" onClick={() => { deleteImagePath() }}>画像を削除する</button>}
                                {previewImage && <button type="button" onClick={() => { deleteSelectedImage() }}>画像を削除する</button>}      </div>
                            <div className="schedule-contents-contents">
                                日時：<input type="date" name="date" value={addData.date || ""} className="schedule-add-date" onChange={handleAddContents} /><br />
                                タイトル：<input name="title" value={addData.title || ""} onChange={handleAddContents} /><br />
                                会場：<input name="location" value={addData.location || ""} onChange={handleAddContents} /><br />
                                住所：<input name="address" value={addData.address || ""} onChange={handleAddContents} /><br />
                                <br />
                                Open:<input name="open_time" value={addData.open_time || ""} onChange={handleAddContents} />/Start:<input name="start_time" value={addData.start_time || ""} onChange={handleAddContents} /><br />
                                adv:<input name="adv_price" value={addData.adv_price || ""} onChange={handleAddContents} />/door:<input name="door_price" value={addData.door_price || ""} onChange={handleAddContents} />/<input name="drink_price" value={addData.drink_price || ""} onChange={handleAddContents} /><br />
                                <textarea name="etc" value={addData.etc || ""} onChange={handleAddContents} /><br />
                                <br />
                                出演：<input name="artist" value={addData.artist || ""} onChange={handleAddContents} /><br />
                                <br />
                                <textarea name="contents" value={addData.contents || ""} onChange={handleAddContents} />



                            </div>


                        </div>

                    </div>




                </form>
            </section>

            {/* DBから取得したコンテンツを表示 */}
            {!nowEditing ? (
                getScheduleDate.map((item, index) => {
                    return (
                        <div key={index}>
                            <div className="schedule-contents-wrapper" id={item.id}>

                                <div className="schedule-contents-title-wrapper">
                                    <div className="schedule-contents-title-inner">
                                        <div className="schedule-contents-date">
                                            {insertStr(item.date)}
                                        </div>
                                        <div className="schedule-contents-location">
                                            @{item.location}
                                        </div>
                                        <div className="schedule-contents-title">
                                            【{item.title}】
                                        </div>
                                    </div>
                                    <div>
                                        <button className="schedule-controll-button" id={item.id} onClick={(e) => handleSelect(e)}>編集</button>
                                        <button className="schedule-controll-button" id={item.id} onClick={() => { deleteContent(item.id) }}>削除</button>

                                    </div>
                                </div>
                                <div className="schedule-contents-body">
                                    <div className="schedule-image">
                                        {item.image_path ? <a href={`${BASE_URL}/${item.image_path}`} target="_blank"><img src={`${BASE_URL}/${item.image_path}`} alt={item.id} className="schedule-image-image" /> </a> : <NoImageController />}
                                    </div>
                                    <div className="schedule-contents-contents">
                                        日時：{insertStr(item.date)}<br />
                                        会場：{item.location}<br />
                                        {item.address}<br />
                                        <br />
                                        Open:{item.open_time}/Start:{item.start_time}<br />
                                        adv:{item.adv_price}/door:{item.door_price}/{item.drink_price}<br />
                                        {item.etc}<br />
                                        <br />
                                        出演：{item.artist}<br />
                                        <br />
                                        <div dangerouslySetInnerHTML={createSafeHTML(item.contents)} />



                                    </div>


                                </div>

                            </div>

                        </div>
                    );
                })

            ) : (


                <div>

                    {/* 編集プレビュー */}
                    <div>
                        <div className="schedule-contents-wrapper" id={selectedData.id}>

                            <div className="schedule-contents-title-wrapper">
                                <div className="schedule-contents-title-inner">
                                    <div className="schedule-contents-date">
                                        {insertStr(previewContent.date)}
                                    </div>
                                    <div className="schedule-contents-location">
                                        @{previewContent.location}
                                    </div>
                                    <div className="schedule-contents-title">
                                        【{previewContent.title}】
                                    </div>
                                </div>
                                <div>
                                    {/* <button className="schedule-controll-button" id={previewContent.id} onClick={() => { setNowEditing(true) }}>編集</button>
                                    <button className="schedule-controll-button" id={previewContent.id} onClick={() => { deleteContent(previewContent.id) }}>削除</button> */}

                                </div>
                            </div>
                            <div className="schedule-contents-body">
                                <div className="schedule-image">
                                    {previewContent.image_path && <img src={`${BASE_URL}/${previewContent.image_path}`} alt={previewContent.id} className='schedule-image-image' />}
                                    {previewImage && <img src={previewImage} alt="preview" className="schedule-image-image" />}<br />
                                    {!previewImage && !previewContent.image_path && <NoImageController />}
                                    {previewImage && previewContent.image_path && <img src={`${BASE_URL}/${previewContent.image_path}`} alt={previewContent.id} className='schedule-image-image' />}

                                </div>
                                <div className="schedule-contents-contents">
                                    日時：{insertStr(previewContent.date)}<br />
                                    会場：{previewContent.location}<br />
                                    {previewContent.address}<br />
                                    <br />
                                    Open:{previewContent.open_time}/Start:{previewContent.start_time}<br />
                                    adv:{previewContent.adv_price}/door:{previewContent.door_price}/{previewContent.drink_price}<br />
                                    {previewContent.etc}<br />
                                    <br />
                                    出演：{previewContent.artist}<br />
                                    <br />
                                    <div dangerouslySetInnerHTML={createSafeHTML(previewContent.contents)} />



                                </div>


                            </div>

                        </div>

                    </div>

                    {/* 編集画面 */}
                    <div>
                        <form onSubmit={(e) => {
                            e.preventDefault();
                            updateContent(currentId, previewContent);
                        }}>
                            <div className="schedule-contents-wrapper" id="add-schedule">

                                <div className="schedule-contents-title-wrapper">
                                    <div className="schedule-contents-title-inner">
                                        <div className="schedule-contents-title-now-editing">
                                            編集中
                                        </div>
                                        <button type="submit" className="schedule-contents-button">保存</button>
                                        <button className="schedule-contents-button" onClick={() => handleEditMode()}>中止</button>

                                    </div>

                                </div>


                                <div className="schedule-contents-body">
                                    <div className="schedule-image">
                                        {/* {imagePath ? <a href={imagePath} target="_blank"><img src={imagePath} alt={id} className="schedule-image-image" /> </a> : <NoImage />} */}
                                        {previewContent.image_path && <img src={`${BASE_URL}/${previewContent.image_path}`} alt={previewContent.id} className='schedule-image-image' />}
                                        {previewImage && <img src={previewImage} alt="preview" className="schedule-image-image" />}<br />
                                        {!previewImage && !previewContent.image_path && <NoImageController />}
                                        {previewImage && previewContent.image_path && <img src={`${BASE_URL}/${previewContent.image_path}`} alt={previewContent.id} className='schedule-image-image' />}
                                        {!previewContent.image_path && !previewImage && <input type="file" name="image" accept="image/*" onChange={handleImagePreview} ref={fileInputRef} />}
                                        {previewContent.image_path && <button type="button" onClick={() => { deleteImagePath() }}>画像を削除する</button>}
                                        {previewImage && <button type="button" onClick={() => { deleteSelectedImage() }}>画像を削除する</button>}
                                    </div>
                                    <div className="schedule-contents-contents">
                                        日時：<input type="date" name="date" value={previewContent.date || ""} className="schedule-add-date" onChange={handlePreviewContent} /><br />
                                        タイトル：<input name="title" value={previewContent.title || ""} onChange={handlePreviewContent} /><br />
                                        会場：<input name="location" value={previewContent.location || ""} onChange={handlePreviewContent} /><br />
                                        住所：<input name="address" value={previewContent.address || ""} onChange={handlePreviewContent} /><br />
                                        <br />
                                        Open:<input name="open_time" value={previewContent.open_time || ""} onChange={handlePreviewContent} />/Start:<input name="start_time" value={previewContent.start_time || ""} onChange={handlePreviewContent} /><br />
                                        adv:<input name="adv_price" value={previewContent.adv_price || ""} onChange={handlePreviewContent} />/door:<input name="door_price" value={previewContent.door_price || ""} onChange={handlePreviewContent} />/<input name="drink_price" value={previewContent.drink_price || ""} onChange={handlePreviewContent} /><br />
                                        <textarea name="etc" value={previewContent.etc || ""} onChange={handlePreviewContent} /><br />
                                        <br />
                                        出演：<input name="artist" value={previewContent.artist || ""} onChange={handlePreviewContent} /><br />
                                        <br />
                                        <textarea name="contents" value={previewContent.contents || ""} onChange={handlePreviewContent} />



                                    </div>


                                </div>

                            </div>




                        </form>
                    </div>
                </div>

            )}
        </div>
    );

}
export default ScheduleController;